import { SalesForm, SupportForm, FinancialForm, OthersForm } from './index';
import { OriginFormValue } from '../useFinishChatForm/types';

const FORM_PARTS: Record<OriginFormValue, React.ComponentType> = {
  commercial: SalesForm,
  support: SupportForm,
  financial: FinancialForm,
  other: OthersForm,
} as const;

export function isValidOriginFormValue(
  value: string
): value is OriginFormValue {
  return value in FORM_PARTS;
}
export function FormPartFactory(
  part: OriginFormValue
): React.ComponentType | null {
  // Helper para obter o componente com verificação de tipo
  if (isValidOriginFormValue(part)) {
    return FORM_PARTS[part];
  }
  return null;
}
